<template>
  <div>
    <el-select
      filterable
      v-model="selected_empresa.id"
      @change="cambioEmpresa"
      clearable
      placeholder="Seleccionar empresa"
      no-data-text="No hay datos que coincidan"
      no-match-text="No hay datos que coincidan"
      v-if="this.show_companies && !usuarioEmpresa"
    >
      <el-option
        v-for="(empresa, idx) in empresas"
        :key="idx"
        :label="empresa.nombre_empresa"
        :value="empresa.id"
      ></el-option>
    </el-select>
    <div class="row mt-3" v-if="selected_empresa.id">
      <div
        class="col-12 text-center text-muted"
        v-if="selected_empresa.id && !ubicacionesCantidad.length"
      >
        <i class="fa fa-exclamation-triangle"></i>
        La empresa no tiene ubicaciones asignadas
      </div>
      <div class="col-md-12 col-sm-12 col-lg-12" v-else>
        <el-table
          :data="ubicacionesCantidad"
          style="width: 100%;"
          size="mini"
          height="250"
        >
          <el-table-column
            label="Ubicación"
            prop="description"
            sortable
            label-class-name="subtitulo"
            class-name="celda"
          >

            <template slot-scope="scope">
              <p class="my-0 font-weight-bold">{{  scope.row.description}}</p>
              <span>Padre: </span>
              <b-badge
                  v-if="scope.row.parent_location && scope.row.parent_location.description"
                  variant="warning"
              >{{ scope.row.parent_location.description}}</b-badge>
              <b-badge v-else variant="danger" v-text="'NO APLICA'"/>
            </template>


          </el-table-column>
          <el-table-column
            width="90"
            label="Cantidad"
            label-class-name="subtitulo"
            class-name="celda"
          >
            <template slot-scope="scope">
              <b-form-input
                v-if="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                "
                id="cantidad"
                name="cantidad"
                data-vv-as=" "
                v-validate="'required'"
                type="text"
                onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                v-model="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                    .quantity
                "
              />
              <div
                class="text-danger span-error small"
                v-text="errors.first('formCantidad.cantidad')"
              />
            </template>
          </el-table-column>
          <el-table-column
            width="90"
            label="Capacidad"
            label-class-name="subtitulo"
            class-name="celda"
          >
            <template slot-scope="scope">
              <b-form-input
                v-if="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                "
                type="text"
                onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                v-model="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                    .capacity
                "
              />
            </template>
          </el-table-column>
          <el-table-column
            width="90"
            label="Unidad de medida"
            label-class-name="subtitulo"
            class-name="celda"
          >
            <template slot-scope="scope">
              <el-select
                v-if="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                "
                v-model="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                    .sys_list_unit_id
                "
                no-data-text="No hay datos que coincidan"
                no-match-text="No hay datos que coincidan"
              >
                <el-option
                  v-for="item in unidadesDeMedida"
                  :key="item.id"
                  :label="item.lista"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            width="90"
            label="Total"
            label-class-name="subtitulo"
            class-name="celda"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.get_product_ubicacion.get_product_ubicacion_quantity
                "
              >
                <strong>
                  {{
                    calculoTotal(
                      scope.row.get_product_ubicacion
                        .get_product_ubicacion_quantity.quantity,
                      scope.row.get_product_ubicacion
                        .get_product_ubicacion_quantity.capacity,
                      scope.row.get_product_ubicacion
                        .get_product_ubicacion_quantity.sys_list_unit_id,
                    )
                  }}
                </strong>
              </span>
            </template>
          </el-table-column>
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-tooltip
                content="Guardar"
                placement="top"
                popper-class="py-1 px-2"
              >
                <b-button
                  size="sm"
                  class="mr-1 mt-1"
                  variant="primary"
                  @click.prevent="guardarCantidad(scope.row)"
                >
                  <i class="fa fa-floppy-o" />
                </b-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'ubicaciones-cantidad',
  props:{
    IdProducto: {
      type: Number,
      default: null,
      required: true
    },
    show_companies: {
        default: true,
        required: false
    },
    },
  data: function () {
    return {
      empresa_id: null,
    }
  },
  async mounted() {
    await this.getUnidadesDeMedida()
    if(this.selected_empresa.id){
        this.loadCompany();
        await this.cambioEmpresa(this.selected_empresa.id);
    }
  },
  computed: {
    ...mapState('asignacionproductos', [
      'selected_empresa',
      'empresas',
      'ubicacionesCantidad',
      'info',
    ]),
    ...mapState('accidentesMayores', ['unidadesDeMedida']),
    ...mapState("autenticacion", ["usuarioEmpresa"]),
  },
  methods: {
    ...mapActions('asignacionproductos', [
      'listarUbicacionesCantidad',
      'getCamposPersonalizados',
      'getUbicacionProd',
      'guardarUbicacionesCantidad',
    ]),
    ...mapActions('accidentesMayores', ['getUnidadesDeMedida']),
    ...mapMutations('asignacionproductos', ['setInfo']),

    cambioEmpresa(empresa_id) {
      let empresa = this.empresas.find((e) => e.id === empresa_id)
      if (empresa) {
        this.toggleVisibleEmp(empresa, this.IdProducto)
      }
    },
    loadCompany(){
        this.toggleVisibleEmp(this.selected_empresa,this.IdProducto)
    },

    async toggleVisibleEmp(empresa, producto) {
      this.empresa_id = empresa.id
      let data = {
        company_id: this.empresa_id,
        product_id: this.IdProducto,
      }
      await this.listarUbicacionesCantidad(data)
      this.addItemsUbicacionesCantidad()
      await this.getCamposPersonalizados({
        id_empresa: this.empresa_id,
        id_producto: this.IdProducto,
      })
      let ubicaciones = {}
      ubicaciones.empresa = this.empresa_id
      ubicaciones.producto = this.IdProducto
      this.setInfo(ubicaciones)
      await this.getUbicacionProd(this.info)
    },

    addItemsUbicacionesCantidad() {
      this.ubicacionesCantidad.forEach((ele) => {
        if (!ele.get_product_ubicacion.get_product_ubicacion_quantity) {
          ele.get_product_ubicacion.get_product_ubicacion_quantity = {
            capacity: null,
            quantity: null,
            sys_list_unit_id: null,
          }
        }
      })
    },

    calculoTotal(cantidad, capacidad, unidad) {
      let unidad_medida = this.unidadesDeMedida.find((um) => um.id === unidad)
      let calculo = cantidad * capacidad
      let udm = ''
      if (unidad_medida) {
        udm = unidad_medida.lista
      }
      if (Number.isInteger(calculo)) {
        return calculo + ' ' + udm
      } else {
        return calculo.toFixed(2) + ' ' + udm
      }
    },

    async guardarCantidad(item) {
      if (
        item.get_product_ubicacion.get_product_ubicacion_quantity.capacity ==
          null ||
        item.get_product_ubicacion.get_product_ubicacion_quantity.quantity ==
          null ||
        item.get_product_ubicacion.get_product_ubicacion_quantity
          .sys_list_unit_id == null ||
        item.get_product_ubicacion.get_product_ubicacion_quantity.capacity ==
          '' ||
        item.get_product_ubicacion.get_product_ubicacion_quantity.quantity ==
          '' ||
        item.get_product_ubicacion.get_product_ubicacion_quantity
          .sys_list_unit_id == ''
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Todos los campos son obligatorios.',
          showConfirmButton: true,
          timer: 5000,
        })
        return
      }
      let data = {
        prod_product_location_id: item.get_product_ubicacion.id,
        sys_list_unit_id:
          item.get_product_ubicacion.get_product_ubicacion_quantity
            .sys_list_unit_id,
        capacity:
          item.get_product_ubicacion.get_product_ubicacion_quantity.capacity,
        quantity:
          item.get_product_ubicacion.get_product_ubicacion_quantity.quantity,
        company_id: this.empresa_id,
      }
      await this.guardarUbicacionesCantidad(data)
    },
  },
}
</script>
